import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { StepTitle, Panel } from "../common/Field";
import { PointsTable } from "./measurements/PointsTable";
import { AxlesTable, DiagonalsTable, RailsPanel } from "./measurements/OtherTables";

const TABS = [["pontos", "Pontos X·Y·Z"], ["eixos", "Medição por eixos"], ["diagonais", "Diagonais"], ["longarinas", "Longarinas"]];

export default function Step3Measurements({ insp, update }) {
  return (
    <div className="flex flex-col gap-6">
      <StepTitle n={3} title="Medições do chassi" subtitle="Informe as medidas reais obtidas. O sistema nunca preenche medidas não informadas — apenas calcula diferenças a partir dos valores registrados." />
      <Tabs defaultValue="pontos">
        <TabsList className="bg-[#0B1520] border border-[#1E2F45] rounded-sm h-auto p-1 flex-wrap justify-start">
          {TABS.map(([k, l]) => (
            <TabsTrigger key={k} value={k} data-testid={`tab-${k}`} className="rounded-sm font-display font-bold uppercase tracking-wider data-[state=active]:bg-[#FFD500] data-[state=active]:text-[#050B10]">{l}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="pontos" className="mt-4"><Panel title="Pontos de medição" subtitle="Até 100 pontos · coordenadas em mm"><PointsTable insp={insp} update={update} /></Panel></TabsContent>
        <TabsContent value="eixos" className="mt-4"><Panel title="Medição por eixos" subtitle="Eixos 1 a 6 · esquerda / centro / direita"><AxlesTable insp={insp} update={update} /></Panel></TabsContent>
        <TabsContent value="diagonais" className="mt-4"><Panel title="Diagonais" subtitle="Identifica deslocamentos laterais, torções e alterações geométricas"><DiagonalsTable insp={insp} update={update} /></Panel></TabsContent>
        <TabsContent value="longarinas" className="mt-4"><RailsPanel insp={insp} update={update} /></TabsContent>
      </Tabs>
    </div>
  );
}
